import { faLocationDot } from "@fortawesome/pro-regular-svg-icons";
import i18n from "i18next";
import { useGenericDialog } from "src/components/common/dialogs/GenericDialogContext.ts";
import {
	TaskLocation,
	TaskLocationPickerDialog,
} from "src/components/views/tasks/location/TaskLocationPickerDialog.tsx";
import { AavoIconButton } from "src/components/common/buttons/AavoIconButton.tsx";
import { defineAgentUiContextKey } from "src/components/views/ai/assistant/uiContext/agentUiContextKey.ts";

export interface PickLocationButtonProps {
	initialLocation: TaskLocation | undefined;
	onLocationPicked: (location: TaskLocation | null) => void | Promise<void>;
}

export const PickLocationButton = ({ initialLocation, onLocationPicked }: PickLocationButtonProps) => {
	const { openDialog } = useGenericDialog();

	return (
		<AavoIconButton
			icon={faLocationDot}
			tooltip={i18n.t("set_location")}
			color={"primary"}
			onClick={() => {
				openDialog(({ closeDialog }) => ({
					title: i18n.t("task_location"),
					size: "lg",
					agentContext: {
						key: defineAgentUiContextKey("tasks.pickLocation.dialog"),
						data: {
							latitude: initialLocation?.latitude ?? null,
							longitude: initialLocation?.longitude ?? null,
						},
						pathSegments: [i18n.t("task_location")],
					},
					content: (
						<TaskLocationPickerDialog
							initialLocation={initialLocation}
							onCompleted={async (location) => {
								await onLocationPicked(location);
								await closeDialog();
							}}
						/>
					),
				}));
			}}
		/>
	);
};
